import React, { Component } from 'react';
import {
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    // Table
} from 'reactstrap'
import axios from 'axios';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import Draggable from 'react-draggable';
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment';
import { format as formatDate, getDay, getDaysInMonth, getMonth, getYear, parseISO, parseJSON } from 'date-fns'
import FullScreenMobileView from '../FullScreenMobileView'
// import FormHelperText from '@material-ui/core/FormHelperText';
import Autocomplete from '@material-ui/lab/Autocomplete';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import CameraOutlined from '@material-ui/icons/CameraAltOutlined';
import CloseIcon from '@material-ui/icons/Close';
import './styles/modalStyle.css'
import format from 'date-fns/format';
import FileViewDownload from '../FileViewDownload';

class AddToMap extends Component {
    state = {
        activeTab: '1',
        modal: true,
        makeDraggable: false,
        selectedAsset: false,
        asset: 'Hydrant',
        assetInspection: 'HydrantInspection',
        selectInspection: null,
        currentPosition: {
            xRate: 150,
            yRate: 35
        },
        userData: {
            user: this.props.user.Created_User,
            date: new Date(),
            ClientID: this.props.user.ClientID,
        },
        isEdit: this.props.data && this.props.data.GlobalID ? true : false,
        errorList: {},
        notEditingInfo: true,
        notEditingInspection: true,
        originalLatLng: {
            lat: this.props.data.Latitude,
            lng: this.props.data.Longitude,
        },
        inputFiles: [],
        inspectionInputFiles: [],
        tempFile: [],
        removeFileArray: [],
        showWebcam: false
    }

    componentDidMount = async () => {
        const { data } = await axios.get('/api/assetFields')
        const assetFields = data.asset
        this.setState({
            inputObjectArray: assetFields.inputObjectArray,
            inspectionObjectArray: assetFields.inspectionObjectArray,
            serviceData: this.props.serviceData,
            [this.state.asset]: this.props.data && this.props.data.GlobalID ?
                {
                    ...this.state.Hydrant,
                    ...this.props.data
                } : {}
        })
        console.log(navigator)
        if (this.props.data && this.props.data[`${this.state.asset}ID`]) {
            const inputObject = {
                asset: `${this.state.asset}Inspection`,
                values: {
                    [`${this.state.asset}ID`]: this.props.data[`${this.state.asset}ID`],
                    ClientID: this.props.user.ClientID,
                },
                types: this.state.inspectionObjectArray.filter(x => x.name === `${this.state.asset}ID` || x.name === 'ClientID')
            }
            const inspections = await axios.post('/api/assetInspectionSEL', inputObject)
                .then(response => {
                    return response.data.result[0]
                })
                .catch(error => console.log('error', error))
            this.setState({
                inspections: inspections
            })
        }

        window.addEventListener('resize', (event) => {
            if (event.target.innerWidth < 767) {
                this.setState({
                    makeDraggable: true,
                    currentPosition: {
                        xRate: 0,
                        lastY: 0
                    }
                })
            } else {
                this.setState({
                    makeDraggable: false,
                    currentPosition: {
                        xRate: 150,
                        lastY: 150
                    }
                })
            }
        }, true);
    }

    componentWillReceiveProps = async (nextProps) => {
        this.setState({
            userData: {
                user: nextProps.user.Created_User,
                date: new Date(),
                ClientID: nextProps.user.ClientID,
            },
            LatLng: nextProps.addedLatLng,
            [this.state.asset]: nextProps.data && nextProps.data.GlobalID ?
                {
                    ...this.state.Hydrant,
                    ...nextProps.data
                }
                : {
                    ...this.state.Hydrant,
                    ...nextProps.data,
                    Latitude: nextProps.addedLatLng.lat ? nextProps.addedLatLng.lat : null,
                    Longitude: nextProps.addedLatLng.lng ? nextProps.addedLatLng.lng : null
                },
            isEdit: nextProps.data && nextProps.data.GlobalID ? true : false,
            serviceData: nextProps.serviceData,
        })
        if (nextProps.addedLatLng.lat && nextProps.addedLatLng.lng) {
            this.setState({
                latlngError: false
            })
        }

    }

    onSubmit = async (e, inputAssetName) => {
        this.setState({ isSubmitting: true })
        e.preventDefault()
        const data = new FormData()
        console.log(this.state.inputFiles)
        var fileData = {}
        for (var i = 0; i < this.state.inputFiles.length; i++) {
            data.append(`file${i}`, this.state.inputFiles[i].file)
            fileData = {
                ...fileData,
                [`file${i}`]: {
                    fileName: this.state.inputFiles[i].fileName,
                    fileDescription: this.state.inputFiles[i].fileDescription
                }
            }
        }
        data.append(`fileData`, JSON.stringify(fileData))
        for (var pair of data.entries()) {
            console.log(`${pair[0]}: ${pair[1]}`);
        }
        if(this.state.inputFiles && this.state.inputFiles.length !== 0) {
            await axios.post(`/api/uploadAttachment/hydrant/${this.state[this.state.asset][`${this.state.asset}ID`]}`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then(response => {
                })
                .catch(({ response }) => {
                    console.error('error', response.data.error)
                    this.props.onShowError(JSON.stringify(response.data.error, null, 2))
                })
        }

        const requiredFields = this.state.inputObjectArray.filter(x => x.required)
        var isErrors = false
        var errorList = this.state.errorList
        for (let field of requiredFields) {
            if (!this.state[inputAssetName][field.name]) {
                this.setState({
                    isErrors: true
                })
                errorList = {
                    ...errorList,
                    [field.name]: true
                }
                isErrors = true
            }
            this.setState({
                errorList: errorList
            })
        }
        if (isErrors) return;
        if (this.state.isEdit) {
            const inputObject = {
                asset: inputAssetName,
                values: {
                    ...this.state[inputAssetName],
                    Last_Editor: this.state.userData.user,
                    Last_Edited_Date: this.state.userData.date,
                },
                types: this.state.inputObjectArray
            }
            await axios.post('/api/assetUPD', inputObject)
                .then(response => {
                    this.props.refreshDataWithOutClosing()
                    this.setState({ notEditingInfo: true })
                })
                .catch(({ response }) => {
                    console.error('error', response.data.error)
                    this.props.onShowError(JSON.stringify(response.data.error, null, 2))
                })
        } else {
            const { data } = await axios.get('/api/newGUID')
            const GlobalId = Object.values(data.result.flat()[0])[0]
            const inputObject = {
                asset: inputAssetName,
                values: {
                    ...this.state[inputAssetName],
                    Created_User: this.state.userData.user,
                    Created_Date: this.state.userData.date,
                    Last_Editor: this.state.userData.user,
                    Last_Edited_Date: this.state.userData.date,
                    ClientID: this.state.userData.ClientID,
                    GlobalID: GlobalId,
                    DeleteFacility: 'No'
                },
                types: this.state.inputObjectArray
            }
            this.setState({
                inputObject: inputObject,
                pickLocation: true
            })
            this.props.addMarkerToMap()

        }
        this.setState({
            [this.state.asset]: {}
        })
        this.setState({ isSubmitting: false })
    }

    SendToBack = async (inputObject) => {
        if (!this.state.LatLng.lat && !this.state.LatLng.lng) {
            this.setState({
                latlngError: true
            })
        } else {
            inputObject = {
                ...inputObject,
                values: {
                    ...this.state.inputObject.values,
                    Latitude: this.state.LatLng.lat,
                    Longitude: this.state.LatLng.lng
                }
            }

            if (this.state.isEdit) {
                // have to do the edit
                await axios.post('/api/assetUPD', inputObject)
                    .then(response => {
                        this.props.refreshData()
                    })
                    .catch(({ response }) => {
                        console.error('error', response.data.error)
                        this.props.onShowError(JSON.stringify(response.data.error, null, 2))
                    })
            } else {

                await axios.post('/api/assetInsert', inputObject)
                    .then(response => {
                        this.props.refreshData()
                    })
                    .catch(({ response }) => {
                        console.error('error', response.data.error)
                        this.props.onShowError(JSON.stringify(response.data.error, null, 2))
                    })
            }
            this.setState({
                [this.state.asset]: {},
                latlngError: false,
                LatLng: {}
            })
        }

    }

    removeFile = (id) => {
        //check to remove from database or local
        var files = this.state.inputFiles.filter(x => x.id !== id)
        var inspectionFiles = this.state.inspectionInputFiles.filter(x => x.id !== id)
        this.setState({
            inputFiles: files,
            inspectionInputFiles: inspectionFiles
        })
    }

    onInspectionSubmit = async (e, inputAssetName) => {
        e.preventDefault()
        this.setState({ isSubmitting: true })
        e.preventDefault()
        const requiredFields = this.state.inspectionObjectArray.filter(x => x.required)
        var isErrors = false
        var errorList = this.state.errorList
        for (let field of requiredFields) {
            if (!this.state[inputAssetName] || !this.state[inputAssetName][field.name]) {
                this.setState({
                    isErrors: true
                })
                errorList = {
                    ...errorList,
                    [field.name]: true
                }
                isErrors = true
            }
            this.setState({
                errorList: errorList
            })
        }
        if (isErrors) return;
        const data = new FormData()
        console.log(this.state.inputFiles)
        var fileData = {}
        for (var i = 0; i < this.state.inspectionInputFiles.length; i++) {
            data.append(`file${i}`, this.state.inspectionInputFiles[i].file)
            fileData = {
                ...fileData,
                [`file${i}`]: {
                    fileName: this.state.inspectionInputFiles[i].fileName,
                    fileDescription: this.state.inspectionInputFiles[i].fileDescription
                }
            }
        }
        data.append(`fileData`, JSON.stringify(fileData))
        for (var pair of data.entries()) {
            console.log(`${pair[0]}: ${pair[1]}`);
        }
        if(this.state.inputFiles && this.state.inputFiles.length !== 0) {
            await axios.post(`/api/uploadAttachment/hydrantInspection/${this.state[this.state.asset][`${this.state.asset}ID`]}`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then(response => {
                })
                .catch(({ response }) => {
                    console.error('error', response.data.error)
                    this.props.onShowError(JSON.stringify(response.data.error, null, 2))
                })
        }
        if (this.state.isEditingInspection) {
            const inputObject = {
                asset: `${this.state.asset}Inspection`,
                values: {
                    ...this.state[inputAssetName],
                },
                types: this.state.inspectionObjectArray
            }
            // have to do the edit
            
            console.log('----------------', inputObject)
            await axios.post('/api/assetInspectionUPD', inputObject)
                .then(async(response) => {
                    // this.props.refreshData()
                    const refreshObject = {
                        asset: `${this.state.asset}Inspection`,
                        values: {
                            [`${this.state.asset}ID`]: this.props.data[`${this.state.asset}ID`],
                            ClientID: this.props.user.ClientID,
                        },
                        types: this.state.inspectionObjectArray.filter(x => x.name === `${this.state.asset}ID` || x.name === 'ClientID')
                    }
                    await axios.post('/api/assetInspectionSEL', refreshObject)
                        .then(response => {
                            this.setState({
                                inspections: response.data.result[0],
                                selectInspection: false,
                                isEditingInspection: false,
                                [this.state.assetInspection]: {}
                            })
                        })
                        .catch(error => console.log('error', error))
                    
                })
                .catch(({ response }) => {
                    console.error('error', response.data.error)
                    this.props.onShowError(JSON.stringify(response.data.error, null, 2))
                })
        } else {

            const inputObject = {
                asset: `${this.state.asset}Inspection`,
                values: {
                    ...this.state[inputAssetName],
                    [`${this.state.asset}ID`]: this.state[this.state.asset][`${this.state.asset}ID`],
                    GlobalID: this.state[this.state.asset].GlobalID,
                    Created_User: this.state.userData.user,
                    Created_Date: this.state.userData.date,
                    Last_Editor: this.state.userData.user,
                    Last_Edited_Date: this.state.userData.date,
                    ClientID: this.state.userData.ClientID,
                    DeleteFacility: 'No'
                },
                types: this.state.inspectionObjectArray
            }
            await axios.post('/api/assetInspectionInsert', inputObject)
                .then(async(response) => {
                    // this.props.refreshData()
                    const refreshObject = {
                        asset: `${this.state.asset}Inspection`,
                        values: {
                            [`${this.state.asset}ID`]: this.props.data[`${this.state.asset}ID`],
                            ClientID: this.props.user.ClientID,
                        },
                        types: this.state.inspectionObjectArray.filter(x => x.name === `${this.state.asset}ID` || x.name === 'ClientID')
                    }
                    await axios.post('/api/assetInspectionSEL', refreshObject)
                        .then(response => {
                            this.setState({
                                inspections: response.data.result[0],
                                selectInspection: false,
                                isEditingInspection: false,
                                [this.state.assetInspection]: {}
                            })
                        })
                        .catch(error => console.log('error', error))
                })
                .catch(({ response }) => {
                    console.error('error', response.data.error)
                    this.props.onShowError(JSON.stringify(response.data.error, null, 2))
                })

        }
        this.setState({
            [this.state.asset]: {},
            [inputAssetName]: {},
            isSubmitting: false
        })
    }

    AddAsset = () => {
        this.setState({
            selectedAsset: true,
            asset: "Hydrant",
            assetInspection: "Hydrant" + "Inspection"
        })
        //go to database to gets fields
    }

    getInspections = () => {
        if (this.state.inspections && this.state.inspections.length !== 0) {
            return <div style={{ padding: "10px 5px", margin: 'auto', display: 'flex', flexDirection: 'column' }} >{this.state.inspections.map((x, index) =>
                <div style={{ marginBottom: '5px' }}>
                    <Button variant="contained" color="primary" key={index} onClick={() => this.EditInspection(x)}>{format(new Date(x.InspectionDate), 'MM/dd/yyyy')}</Button>
                </div>
            )}</div>
        } else {
            return <div style={{ padding: "10px 5px", margin: 'auto' }}>No Inspections</div>
        }
    }

    EditInspection = (inspection) => {
        this.setState({
            selectInspection: true,
            isEditingInspection: true,
            [this.state.assetInspection]: inspection
        })
    }

    setTextHeight = () => {
        this.setState({ activeTab: '2' })
    }

    addInspection = () => {
        this.setState({ selectInspection: true })
    }

    onDrag = (e, data) => {
        this.setState({
            currentPosition: {
                xRate: data.lastX,
                yRate: data.lastY
            }
        })
    };

    changeValue = (e, name, inputAssetName) => {
        this.setState({
            [inputAssetName]: {
                ...this.state[inputAssetName],
                [name]: e.target.value
            },
            errorList: {
                ...this.state.errorList,
                [name]: false
            }
        })
    }

    getPreviousValues = (optionArray, name) => {
        return [...new Set(optionArray.map(col => col[name]).filter(x => x))].map((option) => option)
    }

    formatDataDate = (date) => {
        if (parseJSON(date) === 'Invalid Date') {
            return formatDate(parseISO(date), 'yyyy-MM-dd')
        } else {
            return moment.utc(date).format('YYYY-MM-DD')
        }


    }

    renderForm = (inputObjectArray, changeValue, inputAssetName, previousValues) => {
        return <div>{inputObjectArray.map((x, index) => x.display &&
            <div key={index} style={inputObjectArray.length - 1 === index ? { paddingBottom: "15px" } : {}}>
                {x.type === 'dropdown' ?
                    <TextField
                        id={x.name}
                        select
                        label={x.displayName}
                        variant='outlined'
                        required={x.required}
                        error={this.state.isErrors && this.state.errorList && this.state.errorList[x.name]}
                        helperText={this.state.isErrors && this.state.errorList && this.state.errorList[x.name] ? `${x.displayName} is required` : null}
                        className="without-padding"
                        InputLabelProps={{ style: { color: '#4285f4' } }}
                        onMouseDown={e => e.preventDefault()}
                        InputProps={{ style: { minWidth: '245px', marginBottom: '10px' } }}
                        SelectProps={{
                            MenuProps: {
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left"
                                },
                                getContentAnchorEl: null
                            }
                        }}
                        value={!this.state[inputAssetName] ? '' : this.state[inputAssetName] && this.state[inputAssetName][x.name] ?
                            this.state[inputAssetName][x.name] === true ? 'Yes' : this.state[inputAssetName][x.name] === false ? 'No' : this.state[inputAssetName][x.name] : this.state[inputAssetName][x.name] === false ? 'No'
                                : ''}
                        // value={this.state[inputAssetName] && this.state[inputAssetName][x.name] ? this.state[inputAssetName][x.name] === true ? 'Yes' : 'No' : this.state[inputAssetName][x.name] === false ? 'No' : this.state[inputAssetName][x.name]}
                        onChange={(e) => changeValue(e, x.name, inputAssetName)}
                    // helperText="Please select your currency"
                    >
                        <MenuItem value={""} hidden></MenuItem>
                        {x.values.split(', ').map(obj => <MenuItem key={obj} value={obj}>{obj}</MenuItem>)}
                    </TextField>
                    : x.type === 'textDropdown' ?
                        <Autocomplete
                            key={index}
                            id={x.name}
                            freeSolo
                            className="without-padding-autocomplete"
                            options={this.getPreviousValues(previousValues, x.name)}
                            value={this.state[inputAssetName] && this.state[inputAssetName][x.name] ? this.state[inputAssetName][x.name] : ''}
                            onChange={(e, newValue) => {
                                this.setState({
                                    [inputAssetName]: {
                                        ...this.state[inputAssetName],
                                        [x.name]: newValue
                                    },
                                    errorList: {
                                        ...this.state.errorList,
                                        [x.name]: false
                                    }
                                })
                            }}
                            // inputValue={this.state[x.name + 'autocomplete'] ? this.state[x.name + 'autocomplete'] : ''}
                            onInputChange={(e, newInputValue) => {
                                this.setState({
                                    [inputAssetName]: {
                                        ...this.state[inputAssetName],
                                        [x.name]: newInputValue
                                    },
                                    errorList: {
                                        ...this.state.errorList,
                                        [x.name]: false
                                    }
                                })
                            }}
                            onMouseDown={e => e.preventDefault()}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label={x.displayName}
                                    variant="outlined"
                                    error={this.state.isErrors && this.state.errorList && this.state.errorList[x.name]}
                                    helperText={this.state.isErrors && this.state.errorList && this.state.errorList[x.name] ? `${x.displayName} is required` : null}
                                    required={x.required}
                                    InputLabelProps={{ style: { color: '#4285f4' } }}
                                />
                            }
                        />
                        : x.type === 'textarea' ?
                            <TextField
                                key={index}
                                label={x.displayName}
                                variant="outlined"
                                required={x.required}
                                error={this.state.isErrors && this.state.errorList && this.state.errorList[x.name]}
                                helperText={this.state.isErrors && this.state.errorList && this.state.errorList[x.name] ? `${x.displayName} is required` : null}
                                className="without-padding"
                                InputLabelProps={{ style: { color: '#4285f4' } }}
                                InputProps={{ style: { minWidth: '245px', height: '100px' } }}
                                multiline
                                name={x.name}
                                type={'text'}
                                value={this.state[inputAssetName] && this.state[inputAssetName][x.name] ? this.state[inputAssetName][x.name] : ''}
                                onChange={(e) => changeValue(e, x.name, inputAssetName)}
                            />
                            : x.type === 'number' ?
                                <TextField
                                    key={index}
                                    label={x.displayName}
                                    variant="outlined"
                                    required={x.required}
                                    error={this.state.isErrors && this.state.errorList && this.state.errorList[x.name]}
                                    helperText={this.state.isErrors && this.state.errorList && this.state.errorList[x.name] ? `${x.displayName} is required` : null}
                                    className="without-padding"
                                    InputLabelProps={{ style: { color: '#4285f4' } }}
                                    InputProps={{ style: { minWidth: '245px', marginBottom: '10px' }, inputProps: { min: 0, step: .01 } }}
                                    name={x.name}
                                    type='number'
                                    value={this.state[inputAssetName] && this.state[inputAssetName][x.name] ? this.state[inputAssetName][x.name] : ''}
                                    // onChange={(e) => changeValue(e, x.name, inputAssetName)}
                                    onChange={(e) => {
                                        console.log(e.target.value)
                                        this.setState({
                                            [inputAssetName]: {
                                                ...this.state[inputAssetName],
                                                [x.name]: parseFloat(e.target.value)
                                            },
                                            errorList: {
                                                ...this.state.errorList,
                                                [x.name]: false
                                            }
                                        })
                                    }}
                                />
                                : x.type === 'date' ?
                                    <TextField
                                        key={index}
                                        onFocus={() => { this.setState({ focused: true }) }}
                                        onBlur={() => { this.setState({ focused: false }) }}
                                        label={x.displayName}
                                        variant="outlined"
                                        required={x.required}
                                        error={this.state.isErrors && this.state.errorList && this.state.errorList[x.name]}
                                        helperText={this.state.isErrors && this.state.errorList && this.state.errorList[x.name] ? `${x.displayName} is required` : null}
                                        className="without-padding"
                                        InputLabelProps={{ style: { color: '#4285f4' } }}
                                        InputProps={{ style: { minWidth: '245px', marginBottom: '10px' } }}
                                        name={x.name}
                                        value={this.state[inputAssetName] && this.state[inputAssetName][x.name] ? this.formatDataDate(this.state[inputAssetName][x.name]) : ''}
                                        type={(this.state[inputAssetName] && this.state[inputAssetName][x.name]) || this.state.focused ? "date" : "text"}
                                        onChange={(e) => changeValue(e, x.name, inputAssetName)}
                                    />
                                    : <TextField
                                        key={index}
                                        label={x.displayName}
                                        variant="outlined"
                                        required={x.required}
                                        error={this.state.isErrors && this.state.errorList && this.state.errorList[x.name]}
                                        helperText={this.state.isErrors && this.state.errorList && this.state.errorList[x.name] ? `${x.displayName} is required` : null}
                                        className="without-padding"
                                        InputLabelProps={{ style: { color: '#4285f4' } }}
                                        InputProps={{ style: { minWidth: '245px', marginBottom: '10px' }, autoComplete: 'off' }}
                                        name={x.name}
                                        type={'text'}
                                        value={this.state[inputAssetName] && this.state[inputAssetName][x.name] ? this.state[inputAssetName][x.name] : ''}
                                        onChange={(e) => changeValue(e, x.name, inputAssetName)}
                                    />}
            </div>)}
            <div style={{ paddingTop: '12px' }}>
                {this.state[inputAssetName] && this.state[inputAssetName].assetFiles && this.state[inputAssetName].assetFiles.length !== 0
                    && this.state[inputAssetName].assetFiles.map((x) => this.state.removeFileArray.includes(x.AttachmentID)
                        ? <div style={{ background: '#00000036', borderRadius: '6px', marginBottom: '8px' }}>
                            <div style={{ fontWeight: '600', textAlign: 'center' }}>Are you sure you want to remove?</div>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <span className='spanDeleteFile' style={{ color: 'green', paddingRight: '20px' }} onClick={() => this.deleteAzureFile(x.AttachmentID)}>Yes</span>
                                <span className='spanDeleteFile' style={{ color: 'red', paddingLeft: '20px' }} onClick={() => this.cancelRemoveFile(x.AttachmentID)}>No</span>
                            </div>
                        </div>
                        : <div key={x.AttachmentID} style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div className='filePill'>
                                <div style={{ display: 'flex' }}>
                                    <InsertDriveFileOutlinedIcon style={{ color: "white", marginBottom: 'auto', marginTop: 'auto' }} />
                                    <div style={{ paddingLeft: '8px' }}>
                                        <div><b style={{ fontWeight: 600 }}>Name: </b>{x.AttachmentName}</div>
                                        <div><b style={{ fontWeight: 600 }}>Description: </b>{x.AttachmentDescription}</div>
                                    </div>
                                </div>
                                <CloseIcon color="secondary" style={{ marginTop: 'auto', marginBottom: 'auto', cursor: 'pointer' }} onClick={() => this.setRemoveFileFlag(x.AttachmentID)} />
                            </div>
                        </div>)
                }
            </div>
        </div>
    }

    getFile = async (id) => {
        const body = {
            path: id
        }
        await axios.post('/api/getFile', body)
            .then((result) => {
                const ImageBase64 = result.data.fileData
                this.setState({
                    fileData: ImageBase64,
                    fileMime: id
                })
                
            })
            .catch(error => console.log('error', error))
    }

    deleteAzureFile = async (id) => {
        await axios.get(`/api/deleteFile/${id}`)
            .then((result) => {
                // refresh hard part
                var newAssetFiles = this.state[this.state.asset].assetFiles.filter(x => x.AttachmentID !== id)
                this.setState({
                    [this.state.asset]: {
                        ...this.state[this.state.asset],
                        assetFiles: newAssetFiles
                    }
                })
                this.props.refreshDataWithOutClosing()
            })
            .catch(error => console.log('error', error))
    }

    renderTextFields = (inputObjectArray, textData) => {
        const theMarkerData = textData
        if (inputObjectArray) {
            return <div>
                {inputObjectArray.map((x) => x.display &&
                    <p className="markerElements" key={x.name}><b style={{ color: '#4285f4' }}>{x.displayName}: </b>
                        <span>{x.name.toLowerCase().includes('date')
                            ? moment.utc(theMarkerData[x.name]).format('MM-DD-YYYY')
                            : typeof theMarkerData[x.name] === "boolean"
                                ? theMarkerData[x.name] ? "Yes" : "No"
                                : theMarkerData[x.name]}</span>
                    </p>
                )}
                <div>
                    {theMarkerData && theMarkerData.assetFiles && theMarkerData.assetFiles.length !== 0
                        && theMarkerData.assetFiles.map((x) =>
                            <div key={x.AttachmentID} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className='displayFilePill' onClick={() => this.getFile(x.StorageLocation)}>
                                    <div>
                                        <div><b style={{ fontWeight: 600 }}>Name: </b>{x.AttachmentName}</div>
                                        <div><b style={{ fontWeight: 600 }}>Description: </b>{x.AttachmentDescription}</div>
                                    </div>
                                    <div style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                                        <InsertDriveFileOutlinedIcon style={{ color: "white" }} />
                                    </div>
                                </div>
                            </div>)
                    }
                </div>
            </div>
        } else {
            return null;
        }
    }

    goToInspectionList = () => {
        this.setState({
            selectInspection: false,
            isEditingInspection: false,
            [this.state.assetInspection]: {}
        })
    }

    move(key) {
        this.setState({
            isMoving: !this.state.isMoving
        });
        if (!this.state.isMoving) {
            this.props.markerFormsProps.moveMarker(key)
        } else {
            key = {
                ...key,
                Latitude: this.state.originalLatLng.lat,
                Longitude: this.state.originalLatLng.lng
            }
            this.props.markerFormsProps.moveMarker(key)
        }
    }

    onSubmitMove = async (e) => {
        const tempData = {
            ...this.state[this.state.asset],
            Latitude: this.state.LatLng.lat,
            Longitude: this.state.LatLng.lng
        }
        await axios.post('/api/hydrantUPD', tempData)
            .then(() => {
                this.setState({
                    isMoving: false
                })
                this.props.markerFormsProps.submit(tempData)
            })
            .catch(error => console.log('error', error))

    }

    deleteMarkerFunction = () => {
        this.props.markerFormsProps.deleteMarker(this.state[this.state.asset])
        this.setState({ [this.state.asset]: {} });
        this.props.cancel();
    }

    grabFile = async (e) => {
        const { id } = e.target
        console.log(e.target.files)
        if (e.target.files && e.target.files.length !== 0) {
            var index = this.state.tempFile ? this.state.tempFile.length ? this.state.tempFile.length : 0 : 0
            this.setState({
                tempFile: [
                    ...this.state.tempFile,
                    {
                        type: id,
                        id: id + index,
                        file: e.target.files[0]
                    }
                ]
            })
            setTimeout(() => {
                var pane = document.getElementById('mapFormTab1');
                pane.scrollTop = 1000;
            }, 300);
        }

    }

    setRemoveFileFlag = (id) => {
        var newRemoveArray = this.state.removeFileArray
        newRemoveArray.push(id)
        this.setState({
            removeFileArray: newRemoveArray
        })
    }

    cancelRemoveFile = (id) => {
        var newRemoveArray = this.state.removeFileArray.filter(x => x !== id)
        this.setState({
            removeFileArray: newRemoveArray
        })
    }

    removeTempFile = (id) => {
        var files = this.state.tempFile.filter(x => x.id !== id)
        this.setState({
            tempFile: files
        })
    }

    exitFileUpload = () => {
        this.setState({
            tempFile: [],
            fileName: null,
            fileDescription: null
        })
    }

    FileUploadStep2 = (inspection) => {
        const fileType = this.state.tempFile[0].file.name.split('.')[this.state.tempFile[0].file.name.split('.').length - 1]
        if (inspection) {
            this.setState({
                inspectionInputFiles: [
                    ...this.state.inspectionInputFiles,
                    {
                        ...this.state.tempFile[0],
                        fileName: `${this.state.fileName}.${fileType}`,
                        fileDescription: this.state.fileDescription,
                        AttachmentName: `${this.state.fileName}.${fileType}`,
                        AttachmentDescription: this.state.fileDescription
                    }
                ],
                tempFile: [],
                fileName: null,
                fileDescription: null
            })
        } else {
            this.setState({
                inputFiles: [
                    ...this.state.inputFiles,
                    {
                        ...this.state.tempFile[0],
                        fileName: `${this.state.fileName}.${fileType}`,
                        fileDescription: this.state.fileDescription,
                        AttachmentName: `${this.state.fileName}.${fileType}`,
                        AttachmentDescription: this.state.fileDescription
                    }
                ],
                tempFile: [],
                fileName: null,
                fileDescription: null
            })
        }

    }

    renderFileUpload = (inspection) => {
        return <div style={{ paddingTop: "10px", paddingBottom: "4px" }}>
            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                <div>
                    <input
                        style={{ display: "none" }}
                        id="temp-contained-button-file"
                        multiple
                        type="file"
                        onChange={(e) => this.grabFile(e)}
                    />
                    <label htmlFor="temp-contained-button-file">
                        <Button variant="contained" color="primary" disabled={this.state.tempFile.length !== 0} component="span" style={{ fontSize: '10px', paddingLeft: '8px', paddingRight: '8px' }}>
                            <InsertDriveFileOutlinedIcon style={{ fontSize: '18px' }} />
                            <span style={{ paddingLeft: '6px' }}>Select File</span>
                        </Button>
                    </label>
                </div>
                <div>
                    <Button variant="contained" color="primary" disabled={this.state.tempFile.length !== 0} component="span" style={{ fontSize: '10px', paddingLeft: '8px', paddingRight: '8px' }} onClick={() => this.setState({ showWebcam: true })}>
                        <CameraOutlined style={{ fontSize: '18px' }} />
                        <span style={{ paddingLeft: '6px' }}>Take Picture</span>
                    </Button>
                </div>
            </div>

            {this.state.tempFile.length !== 0
                && this.state.tempFile.map((x) => <div key={x.id} style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div className='filePill'>
                        <span className='pillspan'>{x.file.name}</span>
                        <CloseIcon style={{ marginTop: 'auto', marginBottom: 'auto', cursor: 'pointer' }} onClick={() => this.removeTempFile(x.id)} />
                    </div>

                </div>)
            }
            {this.state.tempFile.length !== 0 && <div>
                <TextField
                    label="File Name"
                    variant="outlined"
                    // required={x.required}
                    // error={this.state.isErrors && this.state.errorList && this.state.errorList[x.name]}
                    // helperText={this.state.isErrors && this.state.errorList && this.state.errorList[x.name] ? `${x.displayName} is required` : null}
                    className="without-padding"
                    InputLabelProps={{ style: { color: '#4285f4' } }}
                    InputProps={{ style: { minWidth: '245px', marginBottom: '10px' }, autoComplete: 'off' }}
                    name='fileName'
                    type={'text'}
                    value={this.state.fileName}
                    onChange={(e) => this.setState({ fileName: e.target.value })}
                />
                <TextField
                    label="File Description"
                    variant="outlined"
                    // required={x.required}
                    // error={this.state.isErrors && this.state.errorList && this.state.errorList[x.name]}
                    // helperText={this.state.isErrors && this.state.errorList && this.state.errorList[x.name] ? `${x.displayName} is required` : null}
                    className="without-padding"
                    InputLabelProps={{ style: { color: '#4285f4' } }}
                    InputProps={{ style: { minWidth: '245px', height: '100px' } }}
                    multiline
                    name="fileDescription"
                    type={'text'}
                    value={this.state.fileDescription}
                    onChange={(e) => this.setState({ fileDescription: e.target.value })}
                />
                <div className='fileButtonDiv'>
                    <Button variant="outlined" color="primary" className="ButtonShadow" onClick={() => this.FileUploadStep2(inspection)}>Add to List</Button>
                    <Button variant="outlined" color="secondary" className="ButtonShadow" onClick={() => this.exitFileUpload()}>Clear</Button>
                </div>
            </div>}
        </div>
    }

    cameraPic = (image) => {
        var file = new File([image], "capture.png");
        this.setState({
            tempFile: [
                ...this.state.tempFile,
                {
                    type: 'capturedImage',
                    id: 'capturedImage0',
                    file: file
                }
            ],
            showWebcam: false
        })
        setTimeout(() => {
            var pane = document.getElementById('mapFormTab1');
            pane.scrollTop = 1000;
        }, 300)
    }

    cancelPic = () => {
        let video = document.getElementsByTagName('video')[0];
        video.pause();
        video.srcObject.getVideoTracks()[0].stop()
        this.setState({
            showWebcam: false
        })
    }

    render() {
        if (!this.state.selectedAsset && !this.state.isEdit) {
            return (
                <div
                    // position={{
                    //     x: this.state.currentPosition.xRate,
                    //     y: this.state.currentPosition.yRate
                    // }}
                    // disabled={this.state.makeDraggable}
                    // onDrag={this.onDrag.bind(this)}
                    // enableUserSelectHack={false}
                    // defaultClassName="AddToMapContainer"
                    className="AddToMapContainer"
                >
                    <div>
                        <div className="outerContainer">
                            <h2 className="containerHeader">Select an Asset To Add</h2>
                            <div className="assetRow">
                                <img alt="hydrant" src={require('../../fire-hydrant.png')} width='30' height='30'></img>
                                <span style={{ margin: "auto" }}>Hydrants</span>
                                <label className="checkContainer" style={{ marginTop: "3px" }}>
                                    <input type="checkbox" checked="checked" />
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                            <div className="assetRow">
                                <img alt="Sewers" src={require('../../manhole.png')} width='30' height='30'></img>
                                <span style={{ margin: "auto" }}>Sewers</span>
                                <label className="checkContainer" style={{ marginTop: "3px" }}>
                                    <input type="checkbox" disabled />
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-evenly', paddingTop: '15px' }}>
                                <Button variant="contained" color="primary" onClick={(e) => this.AddAsset(e)}>{`Add ${this.state.asset}`}</Button>
                                <Button variant="contained" color="primary" className="ButtonShadow" onClick={() => this.props.cancel()} >Close</Button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div
                    // position={{
                    //     x: this.state.currentPosition.xRate,
                    //     y: this.state.currentPosition.yRate
                    // }}
                    // enableUserSelectHack={false}
                    // disabled={this.state.makeDraggable}
                    // onDrag={this.onDrag.bind(this)}
                    // defaultClassName="AddToMapContainer"
                    className="AddToMapContainer"
                >
                    {this.state.showWebcam
                        ? <FullScreenMobileView
                            cameraPic={this.cameraPic}
                            cancelPic={this.cancelPic}
                        />
                        : null}
                    {this.state.fileData
                        ? <FileViewDownload
                            imageData={this.state.fileData}
                            fileMime={this.state.fileMime}
                            cancelPic={() => this.setState({fileData: null})}
                        />
                        : null}
                        {/* {this.state.fileData && <img src={`data:application/png;base64,${this.state.fileData}`} alt='newIMage'></img>} */}
                    <div>
                        <div className="inputContainer">
                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        active={this.state.activeTab === '1'}
                                        onClick={() => { this.setState({ activeTab: '1' }) }}
                                    // onClick={() => this.props.showTable()}
                                    >
                                        <div style={{ display: "flex" }}>
                                            <b>Info</b>
                                        </div>
                                    </NavLink>
                                </NavItem>
                                {this.state.isEdit && <NavItem>
                                    <NavLink
                                        active={this.state.activeTab === '2'}
                                        onClick={() => this.setTextHeight()}
                                    >
                                        Inspections
                                    </NavLink>
                                </NavItem>}
                            </Nav>
                            {/* className="browser-default custom-select dropdownSelect" */}
                            <TabContent activeTab={this.state.activeTab} className="contentTab2" id='mapFormTab1'>
                                <TabPane tabId="1">
                                    {this.state.isMoving ?
                                        <div style={{ minWidth: "225px" }}>
                                            <p style={{ textAlign: 'center' }}><b>Drag the asset where the new location is and Press Submit.</b></p>
                                            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                                <Button color="primary" className="markerButton" size='sm' onClick={() => this.onSubmitMove(this.state[this.state.asset])}>Submit</Button>
                                                <Button color="danger" className="markerButton" size='sm' onClick={() => this.move(this.state[this.state.asset])}>Cancel</Button>
                                            </div>
                                        </div>
                                        : this.state.notEditingInfo && !this.state.selectedAsset ?
                                            <div>
                                                {this.state.inputObjectArray && this.renderTextFields(this.state.inputObjectArray, this.state[this.state.asset])}
                                                <div className='buttonBar'>
                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <Button variant="contained" color="primary" className="ButtonShadow" onClick={() => this.setState({ notEditingInfo: false })}>Edit</Button>
                                                        <div style={{ padding: '3px' }} />
                                                        <Button variant="contained" color="primary" className="ButtonShadow" onClick={() => { this.setState({ [this.state.asset]: {} }); this.props.cancel(); }} >Close</Button>
                                                    </div>
                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <Button variant="outlined" color="secondary" className="ButtonShadow" onClick={() => this.move(this.state[this.state.asset])} >Move</Button>
                                                        <div style={{ padding: '3px' }} />
                                                        <Button variant="contained" color="secondary" className="ButtonShadow" onClick={() => this.deleteMarkerFunction()} >Delete</Button>
                                                    </div>

                                                </div>
                                            </div>

                                            : this.state.pickLocation && !this.state.isEdit ?
                                                <div>
                                                    <form>
                                                        <p style={{ padding: '29px', textAlign: 'center', fontWeight: 800, fontSize: '15px' }}>Point Click on map where the asset is located and Press Submit.</p>
                                                        {this.state.latlngError ? <p style={{ textAlign: 'center', fontWeight: 800, fontSize: '15px', color: 'red' }}>Select a point on the map.</p> : null}
                                                        <div className='buttonBar'>
                                                            <Button variant="contained" color="primary" className="ButtonShadow" onClick={(e) => this.SendToBack(this.state.inputObject)}>Submit</Button>
                                                            <Button variant="contained" color="secondary" className="ButtonShadow" onClick={() => this.props.cancel()} >Close</Button>
                                                        </div>
                                                    </form>
                                                </div>
                                                : <form>
                                                    {this.state.inputObjectArray && this.renderForm(this.state.inputObjectArray, this.changeValue.bind(this), this.state.asset, this.state.serviceData)}

                                                    {this.state.inputFiles.length !== 0
                                                        && this.state.inputFiles.map((x) => this.state.removeFileArray.includes(x.id)
                                                            ? <div style={{ background: '#00000036', borderRadius: '6px' }}>
                                                                <div style={{ fontWeight: '600', textAlign: 'center' }}>Are you sure you want to remove?</div>
                                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                                    <span className='spanDeleteFile' style={{ color: 'green', paddingRight: '20px' }} onClick={() => this.removeFile(x.id)}>Yes</span>
                                                                    <span className='spanDeleteFile' style={{ color: 'red', paddingLeft: '20px' }} onClick={() => this.cancelRemoveFile(x.id)}>No</span>
                                                                </div>
                                                            </div>
                                                            : <div key={x.id} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                <div className='filePill' style={{ marginBottom: '0px', marginTop: '10px' }}>
                                                                    <div style={{ display: 'flex' }}>
                                                                        <InsertDriveFileOutlinedIcon style={{ color: "white", marginBottom: 'auto', marginTop: 'auto' }} />
                                                                        <div style={{ paddingLeft: '8px' }}>
                                                                            <div><b style={{ fontWeight: 600 }}>Name: </b>{x.AttachmentName}</div>
                                                                            <div><b style={{ fontWeight: 600 }}>Description: </b>{x.AttachmentDescription}</div>
                                                                        </div>
                                                                    </div>
                                                                    <CloseIcon color="secondary" style={{ marginTop: 'auto', marginBottom: 'auto', cursor: 'pointer' }} onClick={() => this.setRemoveFileFlag(x.id)} />
                                                                </div>
                                                            </div>)
                                                    }
                                                    {this.renderFileUpload()}
                                                    <div className='buttonBar'>
                                                        <Button variant="contained" color="primary" className="ButtonShadow" disabled={this.state.isSubmitting} onClick={(e) => this.onSubmit(e, this.state.asset)}>{this.state.isEdit ? 'Submit' : 'Next'}</Button>
                                                        <Button variant="outlined" color="primary" className="ButtonShadow" onClick={() => this.setState({ notEditingInfo: true })} >Back</Button>
                                                        <Button variant="contained" color="secondary" className="ButtonShadow" onClick={() => { this.setState({ [this.state.asset]: {} }); this.props.cancel(); }} >Close</Button>
                                                    </div>
                                                </form>}
                                                {this.state.isErrors ? <div className='errorBarMessage'>There are errors in the Form!</div> : null}
                                </TabPane>

                                {this.state.isEdit && <TabPane tabId="2" id='mapFormTab2'>
                                    {!this.state.selectInspection ?
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                            <div style={{ padding: "10px 5px", margin: 'auto' }}>
                                                <Button variant="contained" color="primary" onClick={(e) => this.addInspection(e)}>Add Inspection</Button>
                                            </div>
                                            <Divider />
                                            <h4 style={{ padding: "2px 5px", margin: 'auto', fontSize: '14px', fontWeight: '500' }}>Inspection History</h4>
                                            {this.getInspections()}
                                            <div className='buttonBarNoShadow'>
                                                <Button variant="contained" color="secondary" className="ButtonShadow" onClick={() => this.props.cancel()} >Close</Button>
                                            </div>
                                        </div>
                                        : this.state.notEditingInspection && this.state[this.state.assetInspection] && this.state[this.state.assetInspection][`${this.state.asset}ID`] ?
                                            <div>
                                                {this.state.inputObjectArray && this.renderTextFields(this.state.inspectionObjectArray, this.state[this.state.assetInspection])}
                                                <div className='buttonBar'>
                                                    <Button variant="contained" color="primary" className="ButtonShadow" onClick={() => this.setState({ notEditingInspection: false })}>Edit</Button>
                                                    <Button variant="outlined" color="primary" className="ButtonShadow" onClick={() => this.goToInspectionList()} >Back</Button>
                                                    <Button variant="outlined" color="secondary" className="ButtonShadow" onClick={() => { this.setState({ [this.state.asset]: {} }); this.props.cancel(); }} >Close</Button>
                                                </div>
                                            </div>
                                            : <div>
                                                <form>
                                                    {this.state.inspectionObjectArray && this.renderForm(this.state.inspectionObjectArray, this.changeValue.bind(this), this.state.assetInspection, this.state.inspections)}
                                                    {this.state.inspectionInputFiles.length !== 0
                                                        && this.state.inspectionInputFiles.map((x) => this.state.removeFileArray.includes(x.id)
                                                            ? <div style={{ background: '#00000036', borderRadius: '6px' }}>
                                                                <div style={{ fontWeight: '600', textAlign: 'center' }}>Are you sure you want to remove?</div>
                                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                                    <span className='spanDeleteFile' style={{ color: 'green', paddingRight: '20px' }} onClick={() => this.removeFile(x.id)}>Yes</span>
                                                                    <span className='spanDeleteFile' style={{ color: 'red', paddingLeft: '20px' }} onClick={() => this.cancelRemoveFile(x.id)}>No</span>
                                                                </div>
                                                            </div>
                                                            : <div key={x.id} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                <div className='filePill' style={{ marginBottom: '0px', marginTop: '10px' }}>
                                                                    <div style={{ display: 'flex' }}>
                                                                        <InsertDriveFileOutlinedIcon style={{ color: "white", marginBottom: 'auto', marginTop: 'auto' }} />
                                                                        <div style={{ paddingLeft: '8px' }}>
                                                                            <div><b style={{ fontWeight: 600 }}>Name: </b>{x.AttachmentName}</div>
                                                                            <div><b style={{ fontWeight: 600 }}>Description: </b>{x.AttachmentDescription}</div>
                                                                        </div>
                                                                    </div>
                                                                    <CloseIcon color="secondary" style={{ marginTop: 'auto', marginBottom: 'auto', cursor: 'pointer' }} onClick={() => this.setRemoveFileFlag(x.id)} />
                                                                </div>
                                                            </div>)
                                                    }
                                                    {!this.renderFileUpload(true)}
                                                    <div className='buttonBar'>
                                                        <Button variant="contained" color="primary" className="ButtonShadow" disabled={this.state.isSubmitting} onClick={(e) => this.onInspectionSubmit(e, this.state.assetInspection)}>Submit</Button>
                                                        <Button variant="outlined" color="primary" className="ButtonShadow" onClick={() => this.goToInspectionList()} >Back</Button>
                                                        <Button variant="contained" color="secondary" className="ButtonShadow" onClick={() => this.props.cancel()} >Close</Button>
                                                    </div>
                                                </form>
                                            </div>}
                                            {this.state.isErrors ? <div className='errorBarMessage'>There are errors in the Form!</div> : null}
                                </TabPane>}

                            </TabContent>
                        </div>
                    </div>
                </div>
            );
        }

    }
}

export default AddToMap;


// WEBPACK FOOTER //
// ./src/components/modals/addToMap.js